import RadioGroup from './components/radio-group'
import RadioIndicator from './components/radio-indicator'
import RadioItem from './components/radio-item'

const RadioComponent = {
  Root: RadioGroup,
  Item: RadioItem,
  Indicator: RadioIndicator
}

export default RadioComponent
